import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function LegalPageLayout({ title, testId, children }) {
  return (
    <Container className="py-5 rwm-legal" data-testid={testId}>
      <Row className="justify-content-center">
        <Col lg={8} md={10}>
          <h1 className="h2 mb-2">{title}</h1>
          <p className="text-muted mb-5">Last updated: June 2026</p>
          {children}
          <hr className="my-4" />
          <p className="text-muted small">
            <Link to="/privacy-policy">Privacy Policy</Link>
            {' · '}
            <Link to="/terms">Terms of Service</Link>
            {' · '}
            <Link to="/cookies">Cookie Policy</Link>
          </p>
        </Col>
      </Row>
    </Container>
  );
}
